export function mapCurrentValuesToForm(currentValues, products) {
  return {
    name: currentValues.name,
    description: currentValues.description,
    price: currentValues.price,
    products,
    notes: currentValues.notes
  }
}
